import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import VueMarkdownWithAnchors from '@/components/VueMarkdownWithAnchors.vue';
import Loading from '@/components/Loading.vue';
const blobsModule = namespace('blobs');
let HivesChapter = class HivesChapter extends Vue {
    constructor() {
        super(...arguments);
        this.chapterMap = {
            introduction: 'Introduction',
            stepByStepFactions: 'Step-By-Step Factions',
            downtime: 'Entertainment and Downtime',
            factionsAndMembership: 'Factions and Membership',
            abilityScores: 'Using Ability Scores',
            equipment: 'Equipment',
            customizationOptions: 'Customization Options',
            enhancedItems: 'Enhanced Items',
            modifiableItems: 'Modifiable Items',
            toolProficiencies: 'Tool Proficiencies',
            changelog: 'Changelog'
        };
    }
    created() {
        this.fetchHivesBlob(this.blobName);
    }
    fetchData() {
        this.fetchHivesBlob(this.blobName);
    }
    get title() {
        return (this.chapterMap[this.chapter] || 'Introduction') + ' | WH' + Vue.prototype.$titleSuffix;
    }
    get blobName() {
        return this.chapterMap[this.chapter] || 'Introduction';
    }
    get blob() {
        const blob = this.hivesBlobs[this.blobName];
        return blob && blob.replace(/\ufffd/g, ' - ');
    }
};
__decorate([
    blobsModule.State
], HivesChapter.prototype, "hivesBlobs", void 0);
__decorate([
    blobsModule.Action
], HivesChapter.prototype, "fetchHivesBlob", void 0);
__decorate([
    Prop(String)
], HivesChapter.prototype, "chapter", void 0);
__decorate([
    Watch('$route')
], HivesChapter.prototype, "fetchData", null);
HivesChapter = __decorate([
    Component({
        components: {
            VueMarkdownWithAnchors,
            Loading
        }
    })
], HivesChapter);
export default HivesChapter;
